import { Col, Row, Tooltip, Typography } from "antd"
import { InfoCircleOutlined } from "@ant-design/icons"
import { useWizardContext } from "../../../WizardContext"
import styles from "./PreviewTicketTypes.module.css"

const { Title, Text } = Typography

const formatPrice = (price) => {
  if (price == null) return null
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(price)
}

export const PreviewTicketTypes = () => {
  const { form, trip } = useWizardContext()
  const ticketTypes = form.getFieldValue("ticket_types") || []
  const ticketTypePrices = form.getFieldValue("ticketTypePrices") || {}
  const apiPriceMap = Object.fromEntries((trip?.ticket_types || []).map((t) => [t.id, t.price]))

  const visibleTickets = ticketTypes.filter((ticket) => {
    const priceEntry = ticketTypePrices[ticket.id]
    return priceEntry ? priceEntry.enabled !== false : ticket.enabled !== false
  })

  if (visibleTickets.length === 0) return null

  return (
    <div className={styles.container}>
      <Title level={3} className={styles.title}>{"Ticket Types & Prices"}</Title>
      <Row gutter={[12, 12]}>
        {visibleTickets.map((ticket) => {
          const apiPrice = apiPriceMap[ticket.id] > 0 ? apiPriceMap[ticket.id] : null
          const price = ticketTypePrices[ticket.id]?.price ?? ticket.price ?? apiPrice
          const formattedPrice = formatPrice(price)

          return (
            <Col key={ticket.id} xs={24} sm={12}>
              <div className={styles.ticketCard}>
                <div className={styles.ticketLeft}>
                  <Text className={styles.ticketName}>{ticket.title}</Text>
                  {ticket.description && (
                    <Tooltip title={ticket.description}>
                      <InfoCircleOutlined className={styles.infoIcon} />
                    </Tooltip>
                  )}
                </div>
                {formattedPrice && (
                  <Text className={styles.ticketPrice}>{`from ${formattedPrice}`}</Text>
                )}
              </div>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}
